<script lang="ts">
    import { colors } from "$lib/data"
    import { draw, fade } from "svelte/transition"
    import { quintOut } from "svelte/easing"

    export let section: number
</script>

<svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1152 107.653"
    xml:space="preserve"
    id="show"
>
    <path
        fill="none"
        in:draw={{ duration: 750, easing: quintOut }}
        out:fade={{
            delay: 0,
            duration: 100,
            easing: quintOut
        }}
        style:stroke={colors[section].highlight}
        stroke-width="26"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-miterlimit="10"
        d="
                M36.118,58.832c0,0,54.775-10.244,79.496-11.501s57.272,16.589,80.996,17.999s98.93-24.741,128.994-26.999
                s58.928,20.921,88.496,26.999s110.104-22.48,137.169-25.202s94.237,24.458,110.318,25.202s58.243-24.741,106.495-26.999
                s98.734,26.255,127.493,26.999s100.563-23.407,119.994-26.999s100.495,20.5,100.495,20.5"
    />
</svg>

<style>
svg {
  text-align: center;
  display: grid;
  place-content: center;
  position: absolute;
  width: calc(100% + 0.2rem);
  left: -0.1rem;
}
</style>
